import Card from "./Card";

const RANK_NAMES = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];

export default function PlayerArea({
  cards,
  info,
  action,
  stack,
  bet,
  text,
  active,
  enabled,
  hand,
  won,
  leading,
}) {
  return (
    <div
      className={
        "PlayerArea" + (active ? " Active" : "") + (won ? " Won" : "") + (enabled ? "" : " Disabled")
      }
    >
      <div className="Row Spread">
        <div className="Name">{info.name}</div>
        <div className={"Badge " + (action || "")}>{action || "NONE"}</div>
      </div>
      <div className="Row Spread">
        {cards.map((c) => (
          <Card card={c} key={c} />
        ))}
        <div style={{ position: "relative" }}>
          <img
            className="Avatar"
            src={info.avatar}
          />
          <div className="Coin Big">{stack}</div>
        </div>
        {bet > 0 && <div className="Coin">{bet}</div>}
      </div>
      {text && active && (
        <div className="Text">
          <div>{text}</div>
        </div>
      )}
      {hand && (
        <div className={"Hand" + (leading ? " Hand--leading" : "")}>
          <span className="HandName">{hand.name}</span>
          {hand.tiebreak && hand.tiebreak.length > 0 && (
            <span className="HandTiebreak">
              ({hand.tiebreak.map(r => RANK_NAMES[r]).join(', ')})
            </span>
          )}
        </div>
      )}
    </div>
  );
}
